<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="退款单编号" prop="id">
                <a-input v-model="queryParam.id" placeholder="请输入退款单编号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号" prop="orderId">
                <a-input v-model="queryParam.orderId" placeholder="请输入订单编号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户姓名" prop="id">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户姓名" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <template >

              <a-col :md="8" :sm="24">
                <a-form-item label="类型" prop="type">
                  <a-select v-model="queryParam.type" allow-clear>
                    <a-select-option :value="1">仅退款</a-select-option>
                    <a-select-option :value="2">退货退款</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="订单状态" prop="status">
                  <a-select v-model="queryParam.status" allow-clear>
                    <a-select-option :value="1">待审核</a-select-option>
                    <a-select-option :value="2">待退款</a-select-option>
                    <a-select-option :value="3">待寄回</a-select-option>
                    <a-select-option :value="4">已完成</a-select-option>
                    <a-select-option :value="5">已撤销</a-select-option>
                    <a-select-option :value="-1">驳回</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations">
       <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['orderRefund:order/refund:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['orderRefund:order/refund:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['orderRefund:order/refund:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['orderRefund:order/refund:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div> -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <force-create-form
        ref="forceCreateForm"
        @ok="getList"
      />

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" :width="800">
        <div style="display: flex;flex-direction: column" v-if="logistVO.state !=0">
         <span style="font-weight: bold">{{logistVO.name}} : {{logistVO.logisticCode}}</span>
          <span style="margin-top: 10px" v-for="item in logistVO.traces">{{item.acceptTime}}：{{item.acceptStation}}</span>
        </div>
        <div v-else>
          暂无轨迹信息
        </div>
      </a-modal>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="prodName" slot-scope="text, record">
          <p>{{record.goodsName }}</p>
          <p>{{ record.skuName }}</p>
        </span>
        <span slot="id" slot-scope="text, record">
          <p>{{record.id }}</p>
          <p>{{ record.orderId }}</p>
        </span>
        <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.picture"
                :src="record.picture" preview="头像"/>
        </span>
        <span slot="operation" slot-scope="text, record">

           <a v-if="record.status == 2" @click="handleFinish(record)" v-hasPermi="['order:refund:edit']">
            <a-icon type="edit" />完成
          </a>

          <a v-if="record.status != 1" @click="$refs.createForm.handleInfo(record)" v-hasPermi="['order:refund:query']">
            <a-icon type="file" />详情
          </a>
          <br/>
          <a v-if="record.status == 1" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:refund:edit']">
            <a-icon type="edit" />审核
          </a>
           <a v-if="record.type == 2 && record.status == 2" @click="searchLogistics(record.logisticsNumber)" v-hasPermi="['order:refund:query']">
            <a-icon type="search" />查看物流
          </a>
           <a-dropdown v-if="record.status == 1"  v-hasPermi="['system:user:resetPwd', 'system:user:edit']">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  <a-icon type="double-right" />
                  更多
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-hasPermi="['order:refund:edit']">
                    <a @click="$refs.forceCreateForm.handleUpdate(record, undefined)">
                      <a-icon  />
                      强制审核
                    </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOrderRefund,listOrderRefund, delOrderRefund,updateOrderRefund,searchLogistics } from '@/api/orderRefund/orderRefund'
import CreateForm from './modules/CreateForm'
import ForceCreateForm from './modules/ForceCreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderRefund',
  components: {
    CreateForm,
    ForceCreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      previewVisible:false,
      logistVO:{},
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        refundNo: null,
        userId: null,
        goodsId: null,
        prodName: null,
        skuId: null,
        picture: null,
        skuName: null,
        orderId: null,
        orderItemId: null,
        refundMoney: null,
        refundVoucher: null,
        refundScores: null,
        type: null,
        content: null,
        image: null,
        status: null,
        logisticsCompany: null,
        logisticsNumber: null,
        phone: null,
        nickname:"",
        rejectReason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '退款单|订单编号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          width:180,
          scopedSlots: { customRender: 'id' },
        },
        // {
        //   title: '订单编号',
        //   dataIndex: 'orderId',
        //   ellipsis: true,
        //   align: 'center',
        //   width:180
        // },
        {
          title: '用户名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return '退款'
            }else{
              return '退货退款'
            }
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return '待审核'
            }else if(f ==2){
              return '待退款'
            }else if(f ==3){
              return '待寄回'
            }else if(f ==4){
              return '已完成'
            }else if(f ==5){
              return '已撤销'
            }else if(f ==-1){
              return '驳回'
            }
          }
        },
        // {
        //   title: '产品名称',
        //   dataIndex: 'prodName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: 'sku名称',
        //   dataIndex: 'skuName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '商品/规格',
          dataIndex: 'prodName',
          ellipsis: true,
          align: 'center',
          width:170,
          scopedSlots: {customRender: 'prodName'}
        },
        {
          title: '商品图片',
          dataIndex: 'picture',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'image'}
        },

        {
          title: '售后金额',
          dataIndex: 'refundMoney',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '现金券',
          dataIndex: 'refundVoucher',
          ellipsis: true,
          align: 'center'
        },*/
        // {
        //   title: '售后积分数',
        //   dataIndex: 'refundScores',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '驳回原因',
        //   dataIndex: 'rejectReason',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width:180
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询订单售后列表 */
    getList () {
      this.loading = true
     pageOrderRefund(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },
    handleCancel(){
      this.previewVisible = false;
      this.logistVO = {}
    },

    searchLogistics(logisticsNumber){
      searchLogistics(logisticsNumber).then(res=>{
        this.logistVO = res.data
        this.previewVisible = true;
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        refundNo: undefined,
        userId: undefined,
        goodsId: undefined,
        prodName: undefined,
        skuId: undefined,
        picture: undefined,
        skuName: undefined,
        orderId: undefined,
        orderItemId: undefined,
        refundMoney: undefined,
        refundVoucher: undefined,
        refundScores: undefined,
        type: undefined,
        content: undefined,
        image: undefined,
        status: undefined,
        logisticsCompany: undefined,
        logisticsNumber: undefined,
        phone: undefined,
        rejectReason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    handleFinish(row){
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认完结所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return updateOrderRefund({id:row.id,status:4})
            .then((res) => {
              if(res.success){
                that.getList()
                that.$message.success(
                  '操作成功',
                  3
                )
              }else{
                that.$message.error(
                  res.message
                )
              }

            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delOrderRefund(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('orderRefund/order/refund/export', {
            ...that.queryParam
          }, `订单售后_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
